var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.04688 9.99935C1.04688 5.0518 5.05766 1.04102 10.0052 1.04102C14.9528 1.04102 18.9635 5.0518 18.9635 9.99935C18.9635 14.9469 14.9528 18.9577 10.0052 18.9577C5.05766 18.9577 1.04688 14.9469 1.04688 9.99935ZM7.70833 8.37922C7.70833 7.1479 9.08064 6.41346 10.1052 7.09648L12.536 8.717C13.4513 9.32723 13.4513 10.6723 12.536 11.2825L10.1052 12.903C9.08064 13.586 7.70833 12.8516 7.70833 11.6203V8.37922Z",
    fill: "#31B7A9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayFilled);
export default __webpack_public_path__ + "static/media/play-filled.0a2055a97d86970ddb54b0bb5f5316c5.svg";
export { ForwardRef as ReactComponent };